import * as tslib_1 from "tslib";
// Core packages
import { formatDate } from "@angular/common";
import { ElementRef, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
// Third party packages
import { MatDialog, MatPaginator, MatSort } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { AlignmentType, Document, HeadingLevel, HorizontalPositionAlign, HorizontalPositionRelativeFrom, Media, Packer, Paragraph, TextRun, UnderlineType, VerticalPositionAlign, VerticalPositionRelativeFrom } from "docx";
import Docxtemplater from 'docxtemplater';
import * as FileSaver from "file-saver";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import { combineLatest, merge } from "rxjs";
import { concatMap, debounceTime, distinctUntilChanged, finalize, startWith, take, tap } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { isAdditionalServiceActive } from "src/app/modules/companies/additional-services";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { FireSafetyDocsAddDocDialogComponent } from "src/app/modules/companies/components/add-fire-safety-doc-dialog/add-fire-safety-doc-dialog.component";
import { FireSafetyDocsEditDocDialogComponent } from "src/app/modules/companies/components/edit-fire-safety-doc-dialog/edit-fire-safety-doc-dialog.component";
import { FireSafetyDocsQrCodeDialogComponent } from "src/app/modules/companies/components/fire-safety-qr-code-dialog/fire-safety-qr-code-dialog.component";
import { PrintQrcodeDialogComponent } from 'src/app/modules/companies/components/print-qrcode-dialog/print-qrcode-dialog.component';
import { PrivacyStudioDocsAddDocDialogComponent } from 'src/app/modules/companies/components/add-privacy-studio-doc-dialog/add-privacy-studio-doc-dialog.component';
import { PrivacyStudioDocsEditDocDialogComponent } from 'src/app/modules/companies/components/edit-privacy-studio-doc-dialog/edit-privacy-studio-doc-dialog.component';
import { PrivacyDocsLinkDialogComponent } from 'src/app/modules/companies/components/privacy-docs-link-dialog/privacy-docs-link-dialog.component';
import { PrivacyDocsQrCodeDialogComponent } from 'src/app/modules/companies/components/privacy-docs-qr-code-dialog/privacy-docs-qr-code-dialog.component';
import { PrivacyStudioDocsQrCodeDialogComponent } from 'src/app/modules/companies/components/privacy-studio-docs-qr-code-dialog/privacy-studio-docs-qr-code-dialog.component';
import { StudioPrivacyTemplatesDialogComponent } from 'src/app/modules/companies/components/studio-privacy-templates-dialog/studio-privacy-templates-dialog.component';
import { GenericDocsAddDocDialogComponent } from 'src/app/modules/generic-docs/components/add-doc-dialog/add-doc-dialog.component';
import { GenericDocsEditDocDialogComponent } from 'src/app/modules/generic-docs/components/edit-doc-dialog/edit-doc-dialog.component';
import { GenericDocsQrCodeDialogComponent } from 'src/app/modules/generic-docs/components/qr-code-dialog/qr-code-dialog.component';
import { GenericDocsService } from 'src/app/modules/generic-docs/generic-docs.service';
import { DocumentDownloadDialogComponent } from 'src/app/modules/properties/components/document-download-dialog/document-download-dialog.component';
import { SendEmailDialogComponent } from "src/app/modules/properties/components/send-email-dialog/send-email-dialog.component";
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { UsersService } from "src/app/modules/users/users.service";
import { AddCommunicationDialogComponent } from "src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { VideoDialogComponent } from 'src/app/shared/components/dialogs/video-dialog/video-dialog.component';
import { Company } from "src/app/shared/models/company/company.model";
import { ConfigService } from "src/app/shared/services/config.service";
import { FileManagerService } from "src/app/shared/services/file-manager.service";
import { FireSafetyDocsService } from 'src/app/shared/services/fire-safety-docs.service';
import { HelperService } from "src/app/shared/services/helper.service";
import { ListsService } from "src/app/shared/services/lists.service";
import { PrivacyDocsService, PROPERTY_PRIVACY_TEMPLATE, SUPPLIER_PRIVACY_TEMPLATE } from 'src/app/shared/services/privacy-docs.service';
import { InformativeNoteService } from 'src/app/modules/companies/informative-note.service';
import { PrivacyStudioDocsService } from 'src/app/shared/services/privacy-studio-docs.service';
import { ThemeService } from "src/app/shared/services/theme.service";
import { VideoViewService } from "src/app/shared/services/video-view.service";
import { FireSafetyDocsDataSource } from 'src/app/shared/utils/data-sources/fire-safety-docs-source';
import { GenericDocsDataSource } from 'src/app/shared/utils/data-sources/generic-docs-source';
import { PrivacyDocsDataSource } from 'src/app/shared/utils/data-sources/privacy-docs-source';
import { PrivacyStudioDocsDataSource } from 'src/app/shared/utils/data-sources/privacy-studio-docs-source';
import { VideoViewDataSource } from "src/app/shared/utils/data-sources/video-view-data-source";
var ViewCompanyComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ViewCompanyComponent(configService, companiesService, router, toastrService, helperService, translateService, themeService, authService, dialog, newMessageDialog, cookieService, fileService, listsService, videoViewService, genericDocsService, fireSafetyDocsService, usersService, privacyDocsService, privacyStudioDocsService, suppliersService, informativeNoteService) {
        this.configService = configService;
        this.companiesService = companiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.dialog = dialog;
        this.newMessageDialog = newMessageDialog;
        this.cookieService = cookieService;
        this.fileService = fileService;
        this.listsService = listsService;
        this.videoViewService = videoViewService;
        this.genericDocsService = genericDocsService;
        this.fireSafetyDocsService = fireSafetyDocsService;
        this.usersService = usersService;
        this.privacyDocsService = privacyDocsService;
        this.privacyStudioDocsService = privacyStudioDocsService;
        this.suppliersService = suppliersService;
        this.informativeNoteService = informativeNoteService;
        this.subscriptions = [];
        this.loggedUserMaster = false;
        this.loggedUserAdminOrOperator = false;
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.company = new Company();
        this.detailCardIsLoading = true;
        // Additional services: each section is shown only when its own contract flag is on
        this.safetyVideoSuppliersActive = false;
        this.safetyVideoResidentsActive = false;
        this.fireSafetyActive = false;
        // BEGIN - Add company form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.anagraphicFields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        // END - Add company form
        // BEGIN - Table safetyVideoSuppliers
        this.safetyVideoSuppliersDisplayedColumns = [
            "index",
            "firstName",
            "lastName",
            "companyName",
            "createdAt",
        ];
        this.safetyVideoSuppliersFirstNameFilter = new FormControl("");
        this.safetyVideoSuppliersLastNameFilter = new FormControl("");
        this.safetyVideoSuppliersCompanyNameFilter = new FormControl("");
        this.safetyVideoSuppliersCreatedAtFilter = new FormControl("");
        this.safetyVideoSuppliersCardIsLoading = false;
        // BEGIN - Table safetyVideoResidents
        this.safetyVideoResidentsDisplayedColumns = [
            "index",
            "firstName",
            "lastName",
            "companyName",
            "createdAt",
        ];
        this.safetyVideoResidentsFirstNameFilter = new FormControl("");
        this.safetyVideoResidentsLastNameFilter = new FormControl("");
        this.safetyVideoResidentsCompanyNameFilter = new FormControl("");
        this.safetyVideoResidentsCreatedAtFilter = new FormControl("");
        this.safetyVideoResidentsCardIsLoading = false;
        // BEGIN - Table generic docs
        this.genericDocsDisplayedColumns = ['index', 'name', 'description', 'createdAt', 'createdBy', 'actions'];
        // @ViewChild('genericDocsInput', { static: false }) genericDocsInput: ElementRef;
        this.genericDocsNameFilter = new FormControl('');
        this.genericDocsDescriptionFilter = new FormControl('');
        this.genericDocsCreatedAtFilter = new FormControl('');
        // END - Table generic docs
        this.genericDocsCardIsLoading = false;
        // BEGIN - Table fire safety docs - default
        this.fireSafetyDocsDefaultDataSource = [
            {
                _id: "68e62051087b3792d6b89aaa",
                name: this.translateService.instant("companies.fields.fireSafetyDefaultDocs.1.name"),
                description: this.translateService.instant("companies.fields.fireSafetyDefaultDocs.1.description"),
                createdAt: new Date(this.translateService.instant("companies.fields.fireSafetyDefaultDocs.1.createdAt")),
                files: [
                    {
                        _id: "6634d6c7c3c77915076f5c8c",
                        originalName: "GSA-SAG-LP-ALL.pdf",
                        filename: "GSA-SAG-LP-ALL.pdf",
                        path: "uploads/firesafetydocs/GSA-SAG-LP-ALL.pdf",
                        mimetype: "application/pdf",
                        size: 2056192,
                        createdBy: "5ef210e3e5da4742563f4c75",
                        createdAt: "2024-05-17T12:21:25.740+00:00",
                        updatedAt: "2024-05-17T12:21:25.740+00:00"
                    }
                ]
            }
        ];
        this.fireSafetyDocsefaultDisplayedColumns = ['index', 'name', 'description', 'createdAt', 'actions'];
        // END - Table fire safety docs - default
        // BEGIN - Table fire safety docs
        this.fireSafetyDocsDisplayedColumns = ['index', 'name', 'description', 'createdAt', 'actions'];
        // @ViewChild('fireSafetyDocsInput', { static: false }) fireSafetyDocsInput: ElementRef;
        this.fireSafetyDocsNameFilter = new FormControl('');
        this.fireSafetyDocsDescriptionFilter = new FormControl('');
        this.fireSafetyDocsCreatedAtFilter = new FormControl('');
        // END - Table fire safety docs
        this.fireSafetyDocsCardIsLoading = false;
        // BEGIN - Table privacy docs
        this.privacyDocsDisplayedColumns = ['index', 'type', 'description', 'createdAt', 'actions'];
        // END - Table "Nota informativa" docs
        this.privacyDocsCardIsLoading = true;
        this.privacyDocsSendPecDisabled = false;
        // BEGIN - Table privacy studio docs
        this.privacyStudioDocsDisplayedColumns = ['index', 'checkbox', 'type', 'description', 'createdAt', 'actions'];
        this.privacyStudioDocsTypeFilter = new FormControl('');
        this.privacyStudioDocsDescriptionFilter = new FormControl('');
        this.privacyStudioDocsCreatedAtFilter = new FormControl('');
        this.selectedPrivacyStudioDocs = [];
        // END - Table privacy studio docs
        this.suppliers = true;
        this.hiddenCardPrivacy = true;
        this.privacySagActive = false;
        this.privacyActive = false;
        // "Nota informativa": condo-owner privacy access key without Privacy SAG
        this.informativeNoteActive = false;
        this.informativeNoteDocIsLoading = false;
        this.availableProperties = [];
        // disclaimer
        this.disclaimer = false;
        this.disclaimerAt = '';
        this.disclaimerUser = '';
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.companyId = this.cookieService.get("requestedCompany");
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        this.subscriptions.push(this.authService.loggedUserRequestedRole$.subscribe(function (res) { return (_this.loggedUserRequestedRole = res); }));
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return obj._id.toString() === _this.loggedUserRequestedRole.toString();
        });
        // If requesting user is not master or collaborator, reject request and redirect to home
        if (this.currentRole.role.type === "master" ||
            this.currentRole.role.type === "collaborator") {
            this.loggedUserMaster = true;
        }
        if (this.currentRole.role.type === "admin" ||
            this.currentRole.role.type === "operator") {
            this.loggedUserAdminOrOperator = true;
        }
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        this.getCompany();
        // Build QR code URLs eagerly to avoid ExpressionChangedAfterItHasBeenCheckedError
        var host = this.configService.frontEndHost;
        this.safetyVideoSuppliersQrcodeData = host + "/qrcode/" + this.companyId + "/safetyVideoSuppliers";
        this.safetyVideoResidentsQrcodeData = host + "/qrcode/" + this.companyId + "/safetyVideoResidents";
        this.safetyVideoSuppliersDataSource = new VideoViewDataSource(this.videoViewService, this.helperService);
        this.safetyVideoResidentsDataSource = new VideoViewDataSource(this.videoViewService, this.helperService);
        this.genericDocsDataSource = new GenericDocsDataSource(this.genericDocsService, this.helperService);
        this.fireSafetyDocsDataSource = new FireSafetyDocsDataSource(this.fireSafetyDocsService, this.helperService);
        this.privacyDocsDataSource = new PrivacyDocsDataSource(this.privacyDocsService, this.helperService);
        this.informativeNoteDocsDataSource = new PrivacyDocsDataSource(this.privacyDocsService, this.helperService);
        this.privacyStudioDocsDataSource = new PrivacyStudioDocsDataSource(this.privacyStudioDocsService, this.helperService);
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.ngAfterViewInit = function () {
        this.initSafetyVideoSuppliersDataTable();
        this.safetyVideoSuppliersCardIsLoading = false;
        this.initSafetyVideoResidentsDataTable();
        this.safetyVideoResidentsCardIsLoading = false;
        this.initGenericDocsDataTable();
        this.genericDocsCardIsLoading = false;
        this.initFireSafetyDocsDataTable();
        this.fireSafetyDocsCardIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.ngOnDestroy = function () {
        this.fileService.reset();
        // Push current list settings to the listsService
        if (this.safetyVideoSuppliersPaginator) {
            // Push current list settings to the listsService
            this.listsService.setListSetting("safetyVideoSuppliers", this.safetyVideoSuppliersPaginator.pageIndex.valueOf(), this.safetyVideoSuppliersPaginator.pageSize.valueOf(), {
                firstNameFilter: this.safetyVideoSuppliersFirstNameFilter.value,
                lastNameFilter: this.safetyVideoSuppliersLastNameFilter.value,
                companyNameFilter: this.safetyVideoSuppliersCompanyNameFilter.value,
                createdAtFilter: this.safetyVideoSuppliersCreatedAtFilter.value,
            });
        }
        if (this.safetyVideoResidentsPaginator) {
            // Push current list settings to the listsService
            this.listsService.setListSetting("safetyVideoResidents", this.safetyVideoResidentsPaginator.pageIndex.valueOf(), this.safetyVideoResidentsPaginator.pageSize.valueOf(), {
                firstNameFilter: this.safetyVideoResidentsFirstNameFilter.value,
                lastNameFilter: this.safetyVideoResidentsLastNameFilter.value,
                companyNameFilter: this.safetyVideoResidentsCompanyNameFilter.value,
                createdAtFilter: this.safetyVideoResidentsCreatedAtFilter.value,
            });
        }
        if (this.genericDocsPaginator) {
            this.listsService.setListSetting('genericDocs', this.genericDocsPaginator.pageIndex.valueOf(), this.genericDocsPaginator.pageSize.valueOf(), {
                name: this.genericDocsNameFilter.value,
                description: this.genericDocsDescriptionFilter.value,
                createdAt: this.genericDocsCreatedAtFilter.value,
            });
            if (this.fireSafetyDocsPaginator) {
                // Push current list settings to the listsService
                this.listsService.setListSetting('fireSafetyDocs', this.fireSafetyDocsPaginator.pageIndex.valueOf(), this.fireSafetyDocsPaginator.pageSize.valueOf(), {
                    name: this.fireSafetyDocsNameFilter.value,
                    description: this.fireSafetyDocsDescriptionFilter.value,
                    createdAt: this.fireSafetyDocsCreatedAtFilter.value,
                });
            }
        }
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Get company data
     */
    ViewCompanyComponent.prototype.getCompany = function () {
        var _this = this;
        this.subscriptions.push(this.companiesService.get(this.companyId).subscribe(function (res) {
            if (res.status) {
                // Set company data
                _this.company.setData(res.data);
                _this.companyData = res.data;
                var companySubscription = _this.company.get('subscription');
                // Companies saved before the split inherit the legacy "additionalServices" flag
                _this.safetyVideoSuppliersActive = isAdditionalServiceActive(companySubscription, "safetyVideoSuppliers");
                _this.safetyVideoResidentsActive = isAdditionalServiceActive(companySubscription, "safetyVideoResidents");
                _this.fireSafetyActive = isAdditionalServiceActive(companySubscription, "fireSafety");
                _this.hiddenCardPrivacy = !(companySubscription &&
                    (companySubscription.privacy || companySubscription.privacySag));
                _this.privacySagActive = !!(companySubscription && companySubscription.privacySag);
                _this.privacyActive = !!(companySubscription && companySubscription.privacy);
                _this.informativeNoteActive = !!(companySubscription && companySubscription.informativeNote);
                _this.suppliers = !!(companySubscription && companySubscription.suppliers);
                _this.getAvailableProperties();
                _this.initPrivacyDocsDataTable();
                _this.initInformativeNoteDocsDataTable();
                _this.privacyDocsCardIsLoading = false;
                _this.initPrivacyStudioDocsDataTable();
                // Disclaimer
                if (res.data.disclaimer &&
                    res.data.disclaimer.check1 &&
                    res.data.disclaimer.check2 &&
                    res.data.disclaimer.check3 &&
                    res.data.disclaimer.check4) {
                    _this.disclaimer = true;
                    _this.disclaimerAt = res.data.disclaimer.dateCheck1;
                    _this.subscriptions.push(_this.usersService.get(res.data.disclaimer.check1UpdatedBy).subscribe(function (res) {
                        if (res.status) {
                            _this.disclaimerUser = res.data.firstName + " " + res.data.lastName;
                        }
                    }));
                }
                // Init edit form
                setTimeout(function () {
                    _this.initForm();
                }, 500);
                // Make detail form card visible by disabling his card-spinner
                _this.detailCardIsLoading = false;
                // If there are no subProperties, let's create an empty array
                if (!_this.company.get("subProperties")) {
                    _this.company.set("subProperties", []);
                }
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "companies", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.helperService.handleError(err);
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Get the list of this company's own properties, used to populate the
     * "generate privacy documents" dialog
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.getAvailableProperties = function () {
        var _this = this;
        this.subscriptions.push(this.companiesService
            .getSubPropertiesList(this.company.getId(), 0)
            .subscribe(function (res) {
            if (res.status && res.data.items && Array.isArray(res.data.items)) {
                _this.availableProperties = res.data.items;
            }
        }));
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.initForm = function () {
        var e_1, _a;
        // Set model
        this.model = this.company.getData();
        var categoriesOptions = [];
        var rawCategories = this.translateService.instant("companies.categories");
        try {
            for (var _b = tslib_1.__values(Object.keys(rawCategories)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trans = _c.value;
                categoriesOptions.push({
                    label: rawCategories[trans],
                    value: trans,
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Set fields
        this.anagraphicFields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "name",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.name"),
                            placeholder: this.translateService.instant("companies.fields.name"),
                            required: true,
                            minLength: 2,
                            maxLength: 100,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "select",
                        key: "types",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.types"),
                            placeholder: this.translateService.instant("companies.fields.types"),
                            required: true,
                            multiple: true,
                            disabled: true,
                            options: [
                                {
                                    value: "owner",
                                    label: this.translateService.instant("companies.types.owner"),
                                },
                                {
                                    value: "manager",
                                    label: this.translateService.instant("companies.types.manager"),
                                },
                            ],
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "vatNumber",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.vatNumber"),
                            placeholder: this.translateService.instant("companies.fields.vatNumber"),
                            required: false,
                            minLength: 0,
                            maxLength: 20,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "taxCode",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.taxCode"),
                            placeholder: this.translateService.instant("companies.fields.taxCode"),
                            required: false,
                            minLength: 0,
                            maxLength: 20,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "email",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.email"),
                            placeholder: this.translateService.instant("companies.fields.email"),
                            required: true,
                            minLength: 5,
                            maxLength: 320,
                            type: "email",
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "pec",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.pec"),
                            placeholder: this.translateService.instant("companies.fields.pec"),
                            required: false,
                            minLength: 5,
                            maxLength: 320,
                            type: "email",
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "sdiCode",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.sdiCode"),
                            placeholder: this.translateService.instant("companies.fields.sdiCode"),
                            required: false,
                            minLength: 6,
                            maxLength: 7,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "address",
                        key: "legalAddress",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.legalAddress"),
                            placeholder: this.translateService.instant("companies.fields.legalAddress"),
                            required: false,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "address",
                        key: "operativeAddress",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.operativeAddress"),
                            placeholder: this.translateService.instant("companies.fields.operativeAddress"),
                            required: false,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "phone",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.phone"),
                            placeholder: this.translateService.instant("companies.fields.phone"),
                            required: true,
                            minLength: 1,
                            maxLength: 15,
                            pattern: this.configService.phonePattern,
                        },
                    },
                    {
                        className: "col-12 col-md-8",
                        type: "input",
                        key: "webSiteUrl",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.webSiteUrl"),
                            placeholder: this.translateService.instant("companies.fields.webSiteUrl"),
                            required: false,
                            minLength: 1,
                            maxLength: 100,
                            pattern: this.configService.webSitePattern,
                        },
                    },
                ],
            },
        ];
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            console.warn("form", this.form);
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"), this.translateService.instant("common.words.error"));
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("companies.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Activate submit button loading status
            _this.formBtnOptions.active = true;
            // Remove subscription from model if company is not of "manager" type
            if (model && model.types && !model.types.includes("manager")) {
                if (model.subscription) {
                    delete model.subscription;
                }
            }
            _this.subscriptions.push(_this.companiesService
                .update(_this.company.getId(), model)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res.status) {
                    _this.toastrService.success(res.message);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                // this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    /**
     * Init safetyVideoSuppliers data table
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.initSafetyVideoSuppliersDataTable = function () {
        var _this = this;
        // Load first set of data
        this.loadSafetyVideoSuppliersPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.safetyVideoSuppliersSort.sortChange.subscribe(function () { return (_this.safetyVideoSuppliersPaginator.pageIndex = 0); }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.safetyVideoSuppliersSort.sortChange, this.safetyVideoSuppliersPaginator.page)
            .pipe(tap(function () { return _this.loadSafetyVideoSuppliersPage(); }))
            .subscribe());
        // // Handle server-side filtering through general search
        // this.subscriptions.push(
        //   fromEvent(this.safetyVideoSuppliersInput.nativeElement, "keyup")
        //     .pipe(
        //       debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        //       distinctUntilChanged(), // Eliminate duplicate values
        //       tap(() => {
        //         this.safetyVideoSuppliersPaginator.pageIndex = 0; // Reset page
        //         this.loadSafetyVideoSuppliersPage();
        //       })
        //     )
        //     .subscribe()
        // );
        // Handle server-side filtering through column-specific search
        // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
        combineLatest([
            this.safetyVideoSuppliersFirstNameFilter.valueChanges.pipe(startWith(null)),
            this.safetyVideoSuppliersLastNameFilter.valueChanges.pipe(startWith(null)),
            this.safetyVideoSuppliersCompanyNameFilter.valueChanges.pipe(startWith(null)),
            this.safetyVideoSuppliersCreatedAtFilter.valueChanges.pipe(startWith(null)),
        ])
            .pipe(debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        distinctUntilChanged() // Eliminate duplicate values
        )
            .subscribe(function (res) {
            // Load page only if at least one value is not null
            if (!res.every(function (value) { return value === null; })) {
                _this.loadSafetyVideoSuppliersPage();
            }
        });
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.loadSafetyVideoSuppliersPage = function () {
        var start = this.safetyVideoSuppliersPaginator.pageIndex * this.safetyVideoSuppliersPaginator.pageSize;
        var length = this.safetyVideoSuppliersPaginator.pageSize;
        var search = {
            firstName: this.safetyVideoSuppliersFirstNameFilter.value,
            lastName: this.safetyVideoSuppliersLastNameFilter.value,
            companyName: this.safetyVideoSuppliersCompanyNameFilter.value,
            createdAt: this.safetyVideoSuppliersCreatedAtFilter.value,
        };
        this.safetyVideoSuppliersDataSource.loadSuppliersVideoItems(this.companyId, start, length, this.safetyVideoSuppliersSort.active, this.safetyVideoSuppliersSort.direction, search);
    };
    /**
     * Reset table's filters
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onResetFiltersSafetyVideoSuppliers = function () {
        // Reset lists service data
        this.listsService.setListSetting("safetyVideoSuppliers", 0, 10, {});
        // Reset tables' filters
        // this.safetyVideoSuppliersInput.nativeElement.value = "";
        this.safetyVideoSuppliersFirstNameFilter.setValue(null);
        this.safetyVideoSuppliersLastNameFilter.setValue(null);
        this.safetyVideoSuppliersCompanyNameFilter.setValue(null);
        this.safetyVideoSuppliersCreatedAtFilter.setValue(null);
        // Reset tables' sorting versus and column
        this.safetyVideoSuppliersSort.direction = "asc";
        this.safetyVideoSuppliersSort.active = "createdAt";
        this.safetyVideoSuppliersSort._stateChanges.next();
        // Reset safetyVideoSuppliersPaginator
        this.safetyVideoSuppliersPaginator.pageIndex = 0;
        this.safetyVideoSuppliersPaginator.pageSize = 10;
        // Reload table's data
        this.loadSafetyVideoSuppliersPage();
    };
    /**
     * Reset given filter value and reload the page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onResetFilterSafetyVideoSuppliers = function (filter) {
        filter.reset();
        this.loadSafetyVideoSuppliersPage();
    };
    /**
     * Reset general search input and dispath a 'keyup' event
     * so that the table re-render his rows
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.resetInputSafetyVideoSuppliers = function () {
        this.safetyVideoSuppliersInput.nativeElement.value = "";
        var event = new KeyboardEvent("keyup");
        this.safetyVideoSuppliersInput.nativeElement.dispatchEvent(event);
    };
    /**
     * Handle click open QRcode safetyVideoSuppliers dialogbox
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onSafetyVideoSuppliersPrintQRcode = function () {
        this.dialog.open(PrintQrcodeDialogComponent, {
            data: {
                qrCode: this.safetyVideoSuppliersQrcodeData,
                name: this.company.get("name"),
                city: this.company.get("legalAddress.city"),
                address: this.company.get("legalAddress.route") + " " + this.company.get("legalAddress.streetNumber")
            },
            width: "700px",
        });
    };
    /**
     * Handle generate QRcode docx
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onSafetyVideoSuppliersGenerateQrCodeDoc = function () {
        var _this = this;
        var qrImage = document
            .getElementById("safetyVideoSuppliersQrcodeDataImage")
            .lastElementChild.lastElementChild.getAttribute("src");
        // Create document data
        var doc = new Document();
        var image = Media.addImage(doc, qrImage, 150, 150, {
            floating: {
                horizontalPosition: {
                    relative: HorizontalPositionRelativeFrom.PAGE,
                    align: HorizontalPositionAlign.CENTER,
                },
                verticalPosition: {
                    relative: VerticalPositionRelativeFrom.PARAGRAPH,
                    align: VerticalPositionAlign.CENTER,
                },
            },
        });
        doc.addSection({
            properties: {},
            children: [
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_1,
                    spacing: { after: 400 },
                    children: [
                        new TextRun({
                            text: "AMMINISTRATORE " + this.company.get("name"),
                            bold: true,
                            allCaps: true,
                            color: "auto",
                            size: 24 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.TITLE,
                    children: [
                        new TextRun({
                            text: "ATTENZIONE",
                            font: "Calibri",
                            color: "FF0000",
                            bold: true,
                            allCaps: true,
                            size: 28 * 2,
                            underline: {
                                color: "FF0000",
                                type: UnderlineType.SINGLE,
                            },
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.TITLE,
                    spacing: { after: 500 },
                    children: [
                        new TextRun({
                            text: "AVVISO A TUTTI I FORNITORI",
                            font: "Calibri",
                            color: "FF0000",
                            bold: true,
                            allCaps: true,
                            size: 28 * 2,
                            underline: {
                                color: "FF0000",
                                type: UnderlineType.SINGLE,
                            },
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_1,
                    spacing: { after: 500 },
                    children: [
                        new TextRun({
                            text: "PRIMA DI ACCEDERE ALLE PARTI COMUNI DEL CONDOMINIO E' NECESSARIO VISUALIZZARE L'INFORMATIVA SULLA SICUREZZA E I DIVIETI",
                            font: "Calibri",
                            color: "FF0000",
                            bold: true,
                            allCaps: true,
                            size: 22 * 2,
                        }),
                    ],
                }),
                new Paragraph(image),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_2,
                    spacing: { before: 2500 },
                    children: [
                        new TextRun({
                            text: "VIDEO INFORMATIVO AMMINISTRATORE " + this.company.get("name"),
                            font: "Times New Roman",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 12 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_2,
                    children: [
                        new TextRun({
                            text: this.company.get("legalAddress.route") + ", " + this.company.get("legalAddress.streetNumber"),
                            font: "Times New Roman",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 12 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_3,
                    spacing: { before: 2000, after: 200 },
                    children: [
                        new TextRun({
                            text: "SI PREGA DI INQUADRARE IL QR-CODE DIRETTAMENTE CON LA FOTOCAMERA DEL VOSTRO DISPOSITIVO (SE ABILITATO) O ATTRAVERSO UN'APPLICAZIONE DEDICATA.",
                            font: "Calibri",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 14 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_3,
                    spacing: { after: 200 },
                    children: [
                        new TextRun({
                            text: "DOPO L'INQUADRATURA IL VIDEO SARA' DISPONIBILE PREVIA BREVE REGISTRAZIONE CON INSERIMENTO DI NOME, COGNOME, NOME AZIENDA.",
                            font: "Calibri",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 14 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_3,
                    children: [
                        new TextRun({
                            text: "BUONA VISIONE",
                            font: "Calibri",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 14 * 2,
                        }),
                    ],
                }),
            ],
        });
        // Used to export the file into a .docx file
        Packer.toBlob(doc).then(function (blob) {
            FileSaver.saveAs(blob, "Cartello-Video-Sicurezza-Fornitori_" + _this.company.get("name") + ".docx");
        });
    };
    /**
     * Handle Qrcode send by email
     */
    ViewCompanyComponent.prototype.onSafetyVideoSuppliersSendQrcodeByEmail = function () {
        var _this = this;
        var qrImage = document
            .getElementById("safetyVideoSuppliersQrcodeDataImage")
            .lastElementChild.lastElementChild.getAttribute("src");
        // Open dialog
        var newMessageDialogRef = this.newMessageDialog.open(AddCommunicationDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                qrImage: qrImage,
                phonebook: this.company.get("phonebook"),
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        newMessageDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
        });
    };
    /**
     * Export safetyVideoSuppliers in a file with given format
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onExportSafetyVideoSuppliers = function () {
        var _this = this;
        var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
        var fileName = this.translateService.instant("companies.detail.exportSafetyVideoSuppliersFile") + " " + date;
        this.subscriptions.push(this.videoViewService.getSuppliersVideoExport(this.companyId).subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: "application/vnd.ms-excel",
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Init safetyVideoResidents data table
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.initSafetyVideoResidentsDataTable = function () {
        var _this = this;
        // Load first set of data
        this.loadSafetyVideoResidentsPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.safetyVideoResidentsSort.sortChange.subscribe(function () { return (_this.safetyVideoResidentsPaginator.pageIndex = 0); }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.safetyVideoResidentsSort.sortChange, this.safetyVideoResidentsPaginator.page)
            .pipe(tap(function () { return _this.loadSafetyVideoResidentsPage(); }))
            .subscribe());
        // // Handle server-side filtering through general search
        // this.subscriptions.push(
        //   fromEvent(this.safetyVideoResidentsInput.nativeElement, "keyup")
        //     .pipe(
        //       debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        //       distinctUntilChanged(), // Eliminate duplicate values
        //       tap(() => {
        //         this.safetyVideoResidentsPaginator.pageIndex = 0; // Reset page
        //         this.loadSafetyVideoResidentsPage();
        //       })
        //     )
        //     .subscribe()
        // );
        // Handle server-side filtering through column-specific search
        // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
        combineLatest([
            this.safetyVideoResidentsFirstNameFilter.valueChanges.pipe(startWith(null)),
            this.safetyVideoResidentsLastNameFilter.valueChanges.pipe(startWith(null)),
            this.safetyVideoResidentsCompanyNameFilter.valueChanges.pipe(startWith(null)),
            this.safetyVideoResidentsCreatedAtFilter.valueChanges.pipe(startWith(null)),
        ])
            .pipe(debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        distinctUntilChanged() // Eliminate duplicate values
        )
            .subscribe(function (res) {
            // Load page only if at least one value is not null
            if (!res.every(function (value) { return value === null; })) {
                _this.loadSafetyVideoResidentsPage();
            }
        });
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.loadSafetyVideoResidentsPage = function () {
        var start = this.safetyVideoResidentsPaginator.pageIndex * this.safetyVideoResidentsPaginator.pageSize;
        var length = this.safetyVideoResidentsPaginator.pageSize;
        var search = {
            firstName: this.safetyVideoResidentsFirstNameFilter.value,
            lastName: this.safetyVideoResidentsLastNameFilter.value,
            companyName: this.safetyVideoResidentsCompanyNameFilter.value,
            createdAt: this.safetyVideoResidentsCreatedAtFilter.value,
        };
        this.safetyVideoResidentsDataSource.loadResidentsVideoItems(this.companyId, start, length, this.safetyVideoResidentsSort.active, this.safetyVideoResidentsSort.direction, search);
    };
    /**
     * Reset table's filters
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onResetFiltersSafetyVideoResidents = function () {
        // Reset lists service data
        this.listsService.setListSetting("safetyVideoResidents", 0, 10, {});
        // Reset tables' filters
        // this.safetyVideoResidentsInput.nativeElement.value = "";
        this.safetyVideoResidentsFirstNameFilter.setValue(null);
        this.safetyVideoResidentsLastNameFilter.setValue(null);
        this.safetyVideoResidentsCompanyNameFilter.setValue(null);
        this.safetyVideoResidentsCreatedAtFilter.setValue(null);
        // Reset tables' sorting versus and column
        this.safetyVideoResidentsSort.direction = "asc";
        this.safetyVideoResidentsSort.active = "createdAt";
        this.safetyVideoResidentsSort._stateChanges.next();
        // Reset safetyVideoResidentsPaginator
        this.safetyVideoResidentsPaginator.pageIndex = 0;
        this.safetyVideoResidentsPaginator.pageSize = 10;
        // Reload table's data
        this.loadSafetyVideoResidentsPage();
    };
    /**
     * Reset given filter value and reload the page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onResetFilterSafetyVideoResidents = function (filter) {
        filter.reset();
        this.loadSafetyVideoResidentsPage();
    };
    /**
     * Reset general search input and dispath a 'keyup' event
     * so that the table re-render his rows
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.resetInputSafetyVideoResidents = function () {
        this.safetyVideoResidentsInput.nativeElement.value = "";
        var event = new KeyboardEvent("keyup");
        this.safetyVideoResidentsInput.nativeElement.dispatchEvent(event);
    };
    /**
     * Handle click open QRcode safetyVideoResidents dialogbox
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onSafetyVideoResidentsPrintQRcode = function () {
        this.dialog.open(PrintQrcodeDialogComponent, {
            data: {
                qrCode: this.safetyVideoResidentsQrcodeData,
                name: this.company.get("name"),
                city: this.company.get("legalAddress.city"),
                address: this.company.get("legalAddress.route") + " " + this.company.get("legalAddress.streetNumber")
            },
            width: "700px",
        });
    };
    /**
     * Handle generate QRcode docx
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onSafetyVideoResidentsGenerateQrCodeDoc = function () {
        var _this = this;
        var qrImage = document
            .getElementById("safetyVideoResidentsQrcodeDataImage")
            .lastElementChild.lastElementChild.getAttribute("src");
        // Create document data
        var doc = new Document();
        var image = Media.addImage(doc, qrImage, 150, 150, {
            floating: {
                horizontalPosition: {
                    relative: HorizontalPositionRelativeFrom.PAGE,
                    align: HorizontalPositionAlign.CENTER,
                },
                verticalPosition: {
                    relative: VerticalPositionRelativeFrom.PARAGRAPH,
                    align: VerticalPositionAlign.CENTER,
                },
            },
        });
        doc.addSection({
            properties: {},
            children: [
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_1,
                    spacing: { after: 400 },
                    children: [
                        new TextRun({
                            text: "AMMINISTRATORE " + this.company.get("name"),
                            bold: true,
                            allCaps: true,
                            color: "auto",
                            size: 24 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.TITLE,
                    children: [
                        new TextRun({
                            text: "ATTENZIONE",
                            font: "Calibri",
                            color: "FF0000",
                            bold: true,
                            allCaps: true,
                            size: 28 * 2,
                            underline: {
                                color: "FF0000",
                                type: UnderlineType.SINGLE,
                            },
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.TITLE,
                    spacing: { after: 500 },
                    children: [
                        new TextRun({
                            text: "AVVISO A TUTTI I CONDOMINI",
                            font: "Calibri",
                            color: "FF0000",
                            bold: true,
                            allCaps: true,
                            size: 28 * 2,
                            underline: {
                                color: "FF0000",
                                type: UnderlineType.SINGLE,
                            },
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_1,
                    spacing: { after: 500 },
                    children: [
                        new TextRun({
                            text: "PRIMA DI ACCEDERE ALLE PARTI COMUNI DEL CONDOMINIO E' NECESSARIO VISUALIZZARE L'INFORMATIVA SULLA SICUREZZA E I DIVIETI",
                            font: "Calibri",
                            color: "FF0000",
                            bold: true,
                            allCaps: true,
                            size: 22 * 2,
                        }),
                    ],
                }),
                new Paragraph(image),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_2,
                    spacing: { before: 2500 },
                    children: [
                        new TextRun({
                            text: "VIDEO INFORMATIVO AMMINISTRATORE " + this.company.get("name"),
                            font: "Times New Roman",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 12 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_2,
                    children: [
                        new TextRun({
                            text: this.company.get("legalAddress.route") + ", " + this.company.get("legalAddress.streetNumber"),
                            font: "Times New Roman",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 12 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_3,
                    spacing: { before: 2000, after: 200 },
                    children: [
                        new TextRun({
                            text: "SI PREGA DI INQUADRARE IL QR-CODE DIRETTAMENTE CON LA FOTOCAMERA DEL VOSTRO DISPOSITIVO (SE ABILITATO) O ATTRAVERSO UN'APPLICAZIONE DEDICATA.",
                            font: "Calibri",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 14 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_3,
                    spacing: { after: 200 },
                    children: [
                        new TextRun({
                            text: "DOPO L'INQUADRATURA IL VIDEO SARA' DISPONIBILE PREVIA BREVE REGISTRAZIONE CON INSERIMENTO DI NOME, COGNOME, NOME AZIENDA.",
                            font: "Calibri",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 14 * 2,
                        }),
                    ],
                }),
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_3,
                    children: [
                        new TextRun({
                            text: "BUONA VISIONE",
                            font: "Calibri",
                            color: "auto",
                            bold: true,
                            allCaps: true,
                            size: 14 * 2,
                        }),
                    ],
                }),
            ],
        });
        // Used to export the file into a .docx file
        Packer.toBlob(doc).then(function (blob) {
            FileSaver.saveAs(blob, "Cartello-Video-Sicurezza-Fornitori_" + _this.company.get("name") + ".docx");
        });
    };
    /**
     * Handle Qrcode send by email
     */
    ViewCompanyComponent.prototype.onSafetyVideoResidentsSendQrcodeByEmail = function () {
        var _this = this;
        var qrImage = document
            .getElementById("safetyVideoResidentsQrcodeDataImage")
            .lastElementChild.lastElementChild.getAttribute("src");
        // Open dialog
        var newMessageDialogRef = this.newMessageDialog.open(AddCommunicationDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                qrImage: qrImage,
                phonebook: this.company.get("phonebook"),
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        newMessageDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
        });
    };
    /**
     * Export safetyVideoResidents in a file with given format
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onExportSafetyVideoResidents = function () {
        var _this = this;
        var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
        var fileName = this.translateService.instant("companies.detail.exportSafetyVideoResidentsFile") + " " + date;
        this.subscriptions.push(this.videoViewService.getResidentsVideoExport(this.companyId).subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: "application/vnd.ms-excel",
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    // ### START - Study archive ###
    /**
     * Init genericDocs data table
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.initGenericDocsDataTable = function () {
        var _this = this;
        // Load first set of data
        this.genericDocsLoadPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.genericDocsSort.sortChange.subscribe(function () { return _this.genericDocsPaginator.pageIndex = 0; }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.genericDocsSort.sortChange, this.genericDocsPaginator.page)
            .pipe(tap(function () { return _this.genericDocsLoadPage(); }))
            .subscribe());
        // Handle server-side filtering through column-specific search
        // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
        this.subscriptions.push(combineLatest([
            this.genericDocsNameFilter.valueChanges.pipe(startWith(null)),
            this.genericDocsDescriptionFilter.valueChanges.pipe(startWith(null)),
            this.genericDocsCreatedAtFilter.valueChanges.pipe(startWith(null)),
        ])
            .pipe(debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        distinctUntilChanged())
            .subscribe(function (res) {
            // Load page only if at least one value is not null
            if (!res.every(function (value) { return value === null; })) {
                _this.genericDocsLoadPage();
            }
        }));
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.genericDocsLoadPage = function () {
        var start = this.genericDocsPaginator.pageIndex * this.genericDocsPaginator.pageSize;
        var length = this.genericDocsPaginator.pageSize;
        var search = {
            name: this.genericDocsNameFilter.value,
            description: this.genericDocsDescriptionFilter.value,
            createdAt: this.genericDocsCreatedAtFilter.value,
        };
        this.genericDocsDataSource.loadDocumentsItems(this.companyId, start, length, this.genericDocsSort.active, this.genericDocsSort.direction, search);
    };
    /**
     * Export generic docs in a file with given format
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onGenericDocsExport = function () {
        var _this = this;
        var date = formatDate(new Date(), 'yyyyMMddhhmmss', 'en-EN');
        var fileName = this.translateService.instant('companies.detail.exportGenericDocsFile') + " " + date;
        this.subscriptions.push(this.genericDocsService.getExport(this.companyId).subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: 'application/vnd.ms-excel'
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Reset table's filters
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onGenericDocsResetFilters = function () {
        // Reset lists service data
        this.listsService.setListSetting('genericDocs', 0, 10, {});
        // Reset tables' filters
        // this.input.nativeElement.value = '';
        this.genericDocsNameFilter.setValue(null);
        this.genericDocsDescriptionFilter.setValue(null);
        this.genericDocsCreatedAtFilter.setValue(null);
        // Reset tables' sorting versus and column
        this.genericDocsSort.direction = "desc";
        this.genericDocsSort.active = "createdAt";
        this.genericDocsSort._stateChanges.next();
        // Reset paginator
        this.genericDocsPaginator.pageIndex = 0;
        this.genericDocsPaginator.pageSize = 10;
        // Reload table's data
        this.genericDocsLoadPage();
    };
    /**
     * Reset given filter value and reload the page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onGenericDocsResetFilter = function (filter) {
        filter.reset();
        this.genericDocsLoadPage();
    };
    /**
     * Reset general search input and dispath a 'keyup' event
     * so that the table re-render his rows
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.genericDocsResetInput = function () {
        // this.genericDocsInput.nativeElement.value = '';
        var event = new KeyboardEvent('keyup');
        // this.genericDocsInput.nativeElement.dispatchEvent(event);
    };
    /**
     * Handler Add new doc
     */
    ViewCompanyComponent.prototype.onGenericDocsAddDoc = function () {
        var _this = this;
        var dialogRef = this.dialog.open(GenericDocsAddDocDialogComponent, {
            data: {
                companyId: this.companyId
            },
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.genericDocsLoadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handler Edit doc
     */
    ViewCompanyComponent.prototype.onGenericDocsEdit = function (data) {
        var _this = this;
        var dialogRef = this.dialog.open(GenericDocsEditDocDialogComponent, {
            data: data,
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.genericDocsLoadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handler Delete doc
     */
    ViewCompanyComponent.prototype.onGenericDocsDelete = function (docId) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('genericDocs.deleteDoc.title'),
                message: this.translateService.instant('genericDocs.deleteDoc.message'),
                btnOkText: this.translateService.instant('common.cta.confirm'),
                btnCancelText: this.translateService.instant('common.cta.close'),
            },
            width: '500px',
            disableClose: true
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res2) {
            if (res2) {
                _this.genericDocsService.delete(_this.companyId, docId)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.genericDocsLoadPage();
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                });
            }
        });
    };
    /**
     * Handler View standard QRcode doc
     */
    ViewCompanyComponent.prototype.onGenericDocsViewQrcode = function (data) {
        this.dialog.open(GenericDocsQrCodeDialogComponent, {
            data: {
                data: data,
                print: false,
            },
            width: "450px",
        });
    };
    /**
     * Handler Print standard QRcode doc
     */
    ViewCompanyComponent.prototype.onGenericDocsPrintQrcode = function (data) {
        this.dialog.open(GenericDocsQrCodeDialogComponent, {
            data: {
                data: data,
                print: true,
            },
            width: "450px",
        });
    };
    /**
     * Handler download files
     */
    ViewCompanyComponent.prototype.onGenericDocsDownload = function (data) {
        this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                documents: data.files,
            },
            width: "600px",
        });
    };
    // ### END - Study archive ###
    // ### START - Safety Fire ###
    /**
     * Init fireSafetyDocs data table
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.initFireSafetyDocsDataTable = function () {
        var _this = this;
        // Load first set of data
        this.fireSafetyDocsLoadPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.fireSafetyDocsSort.sortChange.subscribe(function () { return _this.fireSafetyDocsPaginator.pageIndex = 0; }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.fireSafetyDocsSort.sortChange, this.fireSafetyDocsPaginator.page)
            .pipe(tap(function () { return _this.fireSafetyDocsLoadPage(); }))
            .subscribe());
        // Handle server-side filtering through column-specific search
        // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
        this.subscriptions.push(combineLatest([
            this.fireSafetyDocsNameFilter.valueChanges.pipe(startWith(null)),
            this.fireSafetyDocsDescriptionFilter.valueChanges.pipe(startWith(null)),
            this.fireSafetyDocsCreatedAtFilter.valueChanges.pipe(startWith(null)),
        ])
            .pipe(debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        distinctUntilChanged())
            .subscribe(function (res) {
            // Load page only if at least one value is not null
            if (!res.every(function (value) { return value === null; })) {
                _this.fireSafetyDocsLoadPage();
            }
        }));
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.fireSafetyDocsLoadPage = function () {
        var start = this.fireSafetyDocsPaginator.pageIndex * this.fireSafetyDocsPaginator.pageSize;
        var length = this.fireSafetyDocsPaginator.pageSize;
        var search = {
            name: this.fireSafetyDocsNameFilter.value,
            description: this.fireSafetyDocsDescriptionFilter.value,
            createdAt: this.fireSafetyDocsCreatedAtFilter.value,
        };
        this.fireSafetyDocsDataSource.loadDocumentsItems(this.companyId, start, length, this.fireSafetyDocsSort.active, this.fireSafetyDocsSort.direction, search);
    };
    /**
     * Export generic docs in a file with given format
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsExport = function () {
        var _this = this;
        var date = formatDate(new Date(), 'yyyyMMddhhmmss', 'en-EN');
        var fileName = this.translateService.instant('companies.detail.exportFireSafetyDocsFile') + " " + date;
        this.subscriptions.push(this.fireSafetyDocsService.getExport(this.companyId).subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: 'application/vnd.ms-excel'
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Reset table's filters
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsResetFilters = function () {
        // Reset lists service data
        this.listsService.setListSetting('fireSafetyDocs', 0, 10, {});
        // Reset tables' filters
        // this.input.nativeElement.value = '';
        this.fireSafetyDocsNameFilter.setValue(null);
        this.fireSafetyDocsDescriptionFilter.setValue(null);
        this.fireSafetyDocsCreatedAtFilter.setValue(null);
        // Reset tables' sorting versus and column
        this.fireSafetyDocsSort.direction = "desc";
        this.fireSafetyDocsSort.active = "createdAt";
        this.fireSafetyDocsSort._stateChanges.next();
        // Reset paginator
        this.fireSafetyDocsPaginator.pageIndex = 0;
        this.fireSafetyDocsPaginator.pageSize = 10;
        // Reload table's data
        this.fireSafetyDocsLoadPage();
    };
    /**
     * Reset given filter value and reload the page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsResetFilter = function (filter) {
        filter.reset();
        this.fireSafetyDocsLoadPage();
    };
    /**
     * Reset general search input and dispath a 'keyup' event
     * so that the table re-render his rows
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.fireSafetyDocsResetInput = function () {
        // this.fireSafetyDocsInput.nativeElement.value = '';
        var event = new KeyboardEvent('keyup');
        // this.fireSafetyDocsInput.nativeElement.dispatchEvent(event);
    };
    /**
     * Handler Add new doc
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsAddDoc = function () {
        var _this = this;
        var dialogRef = this.dialog.open(FireSafetyDocsAddDocDialogComponent, {
            data: {
                companyId: this.companyId
            },
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.fireSafetyDocsLoadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handler Edit doc
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsEdit = function (data) {
        var _this = this;
        var dialogRef = this.dialog.open(FireSafetyDocsEditDocDialogComponent, {
            data: data,
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.fireSafetyDocsLoadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handler Delete doc
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsDelete = function (docId) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('fireSafetyDocs.deleteDoc.title'),
                message: this.translateService.instant('fireSafetyDocs.deleteDoc.message'),
                btnOkText: this.translateService.instant('common.cta.confirm'),
                btnCancelText: this.translateService.instant('common.cta.close'),
            },
            width: '500px',
            disableClose: true
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res2) {
            if (res2) {
                _this.fireSafetyDocsService.delete(_this.company.get("_id"), docId)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.fireSafetyDocsLoadPage();
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                });
            }
        });
    };
    /**
     * Handler View standard QRcode doc
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsViewQrcode = function (data) {
        this.dialog.open(FireSafetyDocsQrCodeDialogComponent, {
            data: {
                data: data,
                print: false,
            },
            width: "450px",
        });
    };
    /**
     * Handler Print standard QRcode doc
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsPrintQrcode = function (data) {
        this.dialog.open(FireSafetyDocsQrCodeDialogComponent, {
            data: {
                data: data,
                print: true,
            },
            width: "450px",
        });
    };
    /**
     * Handler download files
     */
    ViewCompanyComponent.prototype.onFireSafetyDocsDownload = function (data) {
        this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                documents: data.files,
            },
            width: "600px",
        });
    };
    // ### END - Fire Safety ###
    /**
     * open pop up Video
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onVideoPopUp = function (videoType) {
        var title = '';
        var videoName = '';
        switch (videoType) {
            case 'SafetyVideoSuppliers':
                title = this.translateService.instant("companies.detail.safetyVideoSuppliersCard.title");
                videoName = 'Archedi-SD3';
                break;
            case 'SafetyVideoResidents':
                title = this.translateService.instant("companies.detail.safetyVideoResidentsCard.title");
                videoName = 'Archedi-Resident';
                break;
        }
        var width = "800px";
        this.dialog.open(VideoDialogComponent, {
            data: {
                title: title,
                videoName: videoName
            },
            width: width,
            maxWidth: width,
        });
    };
    /**
     *  Export contract in docx
     *
     * @since 1.0.0
    */
    ViewCompanyComponent.prototype.onGetContract = function () {
        var _this = this;
        this.detailCardIsLoading = true;
        PizZipUtils.getBinaryContent('https://api.archedi.it/uploads/CONTRATTO-UTILIZZO-PIATTAFORMA-ARCHEDI.docx', function (error, content) {
            try {
                if (error) {
                    throw error;
                }
                var zip = new PizZip(content);
                var doc = new Docxtemplater(zip, {
                    paragraphLoop: true,
                    linebreaks: true,
                });
                doc.setData({
                    company: _this.companyData.name,
                    legalAddress: _this.companyData.legalAddress.route + " " + _this.companyData.legalAddress.streetNumber + " - " + _this.companyData.legalAddress.postalCode + " " + _this.companyData.legalAddress.city + " " + _this.companyData.legalAddress.countryCodeTwo,
                    operativeAddres: _this.companyData.operativeAddress ? _this.companyData.operativeAddress.route + " " + _this.companyData.operativeAddress.streetNumber + " - " + _this.companyData.operativeAddress.postalCode + " " + _this.companyData.operativeAddress.city + " " + _this.companyData.operativeAddress.countryCodeTwo : _this.companyData.legalAddress.route + " " + _this.companyData.legalAddress.streetNumber + " - " + _this.companyData.legalAddress.postalCode + " " + _this.companyData.legalAddress.city + " " + _this.companyData.legalAddress.countryCodeTwo,
                    taxCode: _this.companyData.taxCode ? _this.companyData.taxCode : '……………………………',
                    vatNumber: _this.companyData.vatNumber ? _this.companyData.vatNumber : '……………………………',
                    date: moment(_this.disclaimerAt).isValid() ? moment(_this.disclaimerAt).format('DD-MM-YYYY hh:mm:ss') : '',
                    fullName: _this.disclaimerUser,
                });
                // render the document => replace all occurences
                doc.render();
                var out = doc.getZip().generate({
                    type: 'blob',
                    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                });
                // Output the document using Data-URI
                FileSaver.saveAs(out, 'CONTRATTO-UTILIZZO-PIATTAFORMA-ARCHEDI.docx');
                _this.detailCardIsLoading = false;
            }
            catch (error) {
                _this.detailCardIsLoading = false;
                _this.helperService.handleError(JSON.stringify(error));
            }
        });
    };
    // ### START - Privacy ###
    /**
     * Init privacyDocs data table
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.initPrivacyDocsDataTable = function () {
        var _this = this;
        if (this.hiddenCardPrivacy) {
            // Privacy / Privacy SAG not active for this company: skip the API call entirely
            return;
        }
        // Load first set of data
        this.privacyDocsLoadPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.privacyDocsSort.sortChange.subscribe(function () { return _this.privacyDocsPaginator.pageIndex = 0; }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.privacyDocsSort.sortChange, this.privacyDocsPaginator.page)
            .pipe(tap(function () { return _this.privacyDocsLoadPage(); }))
            .subscribe());
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.privacyDocsLoadPage = function () {
        var start = this.privacyDocsPaginator.pageIndex * this.privacyDocsPaginator.pageSize;
        var length = this.privacyDocsPaginator.pageSize;
        // Companies with "privacySag" see the property and supplier privacy docs; the back-end only
        // supports filtering by a single type value, so both are requested together and
        // filtered/paginated client-side (@see PrivacyDocsDataSource). "privacy" + "suppliers"
        // (but not "privacySag") only sees the supplier doc. "Nota informativa" has its own card.
        var search;
        var allowedTypes;
        if (this.privacySagActive) {
            allowedTypes = [PROPERTY_PRIVACY_TEMPLATE, SUPPLIER_PRIVACY_TEMPLATE];
        }
        else if (this.suppliers) {
            search = { type: SUPPLIER_PRIVACY_TEMPLATE };
        }
        this.privacyDocsDataSource.loadDocumentsItems(this.company.get('_id'), start, length, this.privacyDocsSort.active, this.privacyDocsSort.direction, search, allowedTypes);
    };
    /**
     * Init the "Nota informativa" docs data table (condo-owner privacy notice only)
     *
     * @since 3.0.0
     */
    ViewCompanyComponent.prototype.initInformativeNoteDocsDataTable = function () {
        var _this = this;
        if (!this.informativeNoteActive || !this.informativeNoteDocsSort || !this.informativeNoteDocsPaginator) {
            // "Nota informativa" not active (or its card is not rendered): skip the API call entirely
            return;
        }
        // Load first set of data
        this.informativeNoteDocsLoadPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.informativeNoteDocsSort.sortChange.subscribe(function () { return _this.informativeNoteDocsPaginator.pageIndex = 0; }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.informativeNoteDocsSort.sortChange, this.informativeNoteDocsPaginator.page)
            .pipe(tap(function () { return _this.informativeNoteDocsLoadPage(); }))
            .subscribe());
    };
    /**
     * Load requested "Nota informativa" docs data page
     *
     * @since 3.0.0
     */
    ViewCompanyComponent.prototype.informativeNoteDocsLoadPage = function () {
        var start = this.informativeNoteDocsPaginator.pageIndex * this.informativeNoteDocsPaginator.pageSize;
        var length = this.informativeNoteDocsPaginator.pageSize;
        this.informativeNoteDocsDataSource.loadDocumentsItems(this.company.get('_id'), start, length, this.informativeNoteDocsSort.active, this.informativeNoteDocsSort.direction, { type: PROPERTY_PRIVACY_TEMPLATE });
    };
    /**
     * Check that a privacy doc link is a safe, absolute http(s) URL
     * before using it to navigate or render it inside the UI
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.isValidPrivacyDocLink = function (link) {
        if (!link) {
            return false;
        }
        try {
            var url = new URL(link);
            return url.protocol === 'http:' || url.protocol === 'https:';
        }
        catch (err) {
            return false;
        }
    };
    /**
     * Build the public, unauthenticated URL for this privacy doc's general
     * access page (@see PrivacyDocsPublicAccessComponent): the visitor lands
     * there, enters a property's tax code, and downloads the document once
     * it's confirmed to belong to this company.
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.buildPrivacyDocPublicLink = function (docType) {
        var companyId = this.company.get('_id');
        var segmentByType = {
            "informativa_privacy_immobile": 'condo-owner',
            "informativa_privacy_fornitore": 'supplier',
        };
        var segment = segmentByType[docType];
        if (!companyId || !segment) {
            return null;
        }
        return window.location.origin + "/privacy-docs/" + companyId + "/" + segment;
    };
    /**
     * Handle "Accedi" action: open the privacy doc's public access page in a new tab
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onPrivacyDocsAccess = function (element) {
        var link = this.buildPrivacyDocPublicLink(element && element.type);
        if (!link || !this.isValidPrivacyDocLink(link)) {
            this.toastrService.error(this.translateService.instant('companies.detail.privacyDocsCard.invalidLink'));
            return;
        }
        window.open(link, '_blank', 'noopener,noreferrer');
    };
    /**
     * Handle "Visualizza QR-code" action: open a dialog showing the QR-code
     * that encodes the privacy doc's public access page link
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onPrivacyDocsViewQrcode = function (element) {
        var link = this.buildPrivacyDocPublicLink(element && element.type);
        if (!link || !this.isValidPrivacyDocLink(link)) {
            this.toastrService.error(this.translateService.instant('companies.detail.privacyDocsCard.invalidLink'));
            return;
        }
        this.dialog.open(PrivacyDocsQrCodeDialogComponent, {
            minWidth: '40%',
            data: {
                data: tslib_1.__assign({}, element, { link: link }),
            },
        });
    };
    /**
     * Handle "Visualizza link" action: open a dialog showing the privacy doc's
     * public access page link
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onPrivacyDocsViewLink = function (element) {
        var link = this.buildPrivacyDocPublicLink(element && element.type);
        if (!link || !this.isValidPrivacyDocLink(link)) {
            this.toastrService.error(this.translateService.instant('companies.detail.privacyDocsCard.invalidLink'));
            return;
        }
        this.dialog.open(PrivacyDocsLinkDialogComponent, {
            minWidth: '40%',
            data: {
                data: tslib_1.__assign({}, element, { link: link }),
            },
        });
    };
    // ### END - Privacy ###
    // ### START - Privacy Studio Docs ###
    /**
     * Handle "Genera Nota informativa" action: download the generated PDF
     * (4 QR codes: residents and suppliers safety videos, GSA manual, condo-owner privacy access key)
     *
     * @since 3.0.0
     */
    ViewCompanyComponent.prototype.onInformativeNoteDownload = function () {
        var _this = this;
        if (!this.informativeNoteActive || this.informativeNoteDocIsLoading) {
            return;
        }
        this.informativeNoteDocIsLoading = true;
        this.subscriptions.push(this.informativeNoteService.generateDocumentFile(this.company.get('_id'))
            .pipe(finalize(function () { return _this.informativeNoteDocIsLoading = false; }))
            .subscribe(function (res) { return FileSaver.saveAs(res.blob, res.fileName); }, function (err) { return _this.helperService.handleError(err); }));
    };
    /**
     * Handle "Invia Nota informativa" action: generate the document, upload it and
     * open the email dialog with the document already attached
     *
     * @since 3.0.0
     */
    ViewCompanyComponent.prototype.onInformativeNoteSendByEmail = function () {
        var _this = this;
        if (!this.informativeNoteActive || this.informativeNoteDocIsLoading) {
            return;
        }
        this.informativeNoteDocIsLoading = true;
        this.subscriptions.push(this.informativeNoteService.generateDocumentFile(this.company.get('_id'))
            .pipe(concatMap(function (res) { return _this.informativeNoteService.uploadForEmail(res.blob, res.fileName); }), finalize(function () { return _this.informativeNoteDocIsLoading = false; }))
            .subscribe(function (files) {
            var dialogRef = _this.newMessageDialog.open(SendEmailDialogComponent, {
                minWidth: "60%",
                maxHeight: "98vh",
                data: {
                    phonebook: _this.company.get("phonebook") ? _this.company.get("phonebook") : [],
                    insertedDocs: [],
                    selectedDocs: [],
                    attachments: files,
                    hideInsertedDocs: true,
                    companyData: _this.loggedUserMaster ? _this.companyData : "",
                    propertyName: "",
                    propertyId: "",
                    sentFromSupplierPage: false,
                },
                disableClose: true,
            });
            dialogRef.beforeClosed()
                .pipe(take(1))
                .subscribe(function (res) {
                if (res) {
                    _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
                }
            });
        }, function (err) { return _this.helperService.handleError(err); }));
    };
    /**
     * Handle "Scarica template" action: open a dialog listing the
     * company-level ("studio") privacy document templates available for
     * download, pre-filled with this company's own registry data
     * (Privacy SAG subscription required, gated in the template via
     * privacySagActive)
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onOpenStudioPrivacyTemplatesDialog = function () {
        if (!this.privacySagActive) {
            return;
        }
        this.dialog.open(StudioPrivacyTemplatesDialogComponent, {
            data: {
                companyId: this.company.get("_id"),
            },
            width: "650px",
            disableClose: true,
        });
    };
    /**
     * Init privacyStudioDocs data table
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.initPrivacyStudioDocsDataTable = function () {
        var _this = this;
        if (this.hiddenCardPrivacy) {
            // Privacy / Privacy SAG not active for this company: skip the API call entirely
            return;
        }
        // Load first set of data
        this.privacyStudioDocsLoadPage();
        // Reset pagination after sorting
        this.subscriptions.push(this.privacyStudioDocsSort.sortChange.subscribe(function () { return _this.privacyStudioDocsPaginator.pageIndex = 0; }));
        // Once user change sorting OR change page
        // let's reload the page data
        this.subscriptions.push(merge(this.privacyStudioDocsSort.sortChange, this.privacyStudioDocsPaginator.page)
            .pipe(tap(function () { return _this.privacyStudioDocsLoadPage(); }))
            .subscribe());
        // Handle server-side filtering through column-specific search
        // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
        this.subscriptions.push(combineLatest([
            this.privacyStudioDocsTypeFilter.valueChanges.pipe(startWith(null)),
            this.privacyStudioDocsDescriptionFilter.valueChanges.pipe(startWith(null)),
            this.privacyStudioDocsCreatedAtFilter.valueChanges.pipe(startWith(null)),
        ])
            .pipe(debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        distinctUntilChanged())
            .subscribe(function (res) {
            // Load page only if at least one value is not null
            if (!res.every(function (value) { return value === null; })) {
                _this.privacyStudioDocsLoadPage();
            }
        }));
    };
    /**
     * Load requested data page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.privacyStudioDocsLoadPage = function () {
        var start = this.privacyStudioDocsPaginator.pageIndex * this.privacyStudioDocsPaginator.pageSize;
        var length = this.privacyStudioDocsPaginator.pageSize;
        var search = {
            type: this.privacyStudioDocsTypeFilter.value,
            description: this.privacyStudioDocsDescriptionFilter.value,
            createdAt: this.privacyStudioDocsCreatedAtFilter.value,
        };
        this.privacyStudioDocsDataSource.loadDocumentsItems(this.company.get('_id'), start, length, this.privacyStudioDocsSort.active, this.privacyStudioDocsSort.direction, search);
    };
    /**
     * Export privacy studio docs in a file with given format
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsExport = function () {
        var _this = this;
        var date = formatDate(new Date(), 'yyyyMMddhhmmss', 'en-EN');
        var fileName = this.translateService.instant('companies.detail.exportPrivacyStudioDocsFile') + " " + date;
        this.subscriptions.push(this.privacyStudioDocsService.getExport(this.company.get('_id')).subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: 'application/vnd.ms-excel'
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Reset table's filters
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsResetFilters = function () {
        // Reset lists service data
        this.listsService.setListSetting('privacyStudioDocs', 0, 10, {});
        // Reset tables' filters
        this.privacyStudioDocsTypeFilter.setValue(null);
        this.privacyStudioDocsDescriptionFilter.setValue(null);
        this.privacyStudioDocsCreatedAtFilter.setValue(null);
        // Reset tables' sorting versus and column
        this.privacyStudioDocsSort.direction = "desc";
        this.privacyStudioDocsSort.active = "createdAt";
        this.privacyStudioDocsSort._stateChanges.next();
        // Reset paginator
        this.privacyStudioDocsPaginator.pageIndex = 0;
        this.privacyStudioDocsPaginator.pageSize = 10;
        // Reload table's data
        this.privacyStudioDocsLoadPage();
    };
    /**
     * Reset given filter value and reload the page
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsResetFilter = function (filter) {
        filter.reset();
        this.privacyStudioDocsLoadPage();
    };
    /**
     * Handler Add new doc
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsAddDoc = function () {
        var _this = this;
        var dialogRef = this.dialog.open(PrivacyStudioDocsAddDocDialogComponent, {
            data: {
                companyId: this.company.get("_id")
            },
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.privacyStudioDocsLoadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handler Edit doc
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsEdit = function (data) {
        var _this = this;
        var dialogRef = this.dialog.open(PrivacyStudioDocsEditDocDialogComponent, {
            data: data,
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.privacyStudioDocsLoadPage();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handler Delete doc
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsDelete = function (docId) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('companies.detail.privacyDocsCard.studioSection.dialog.deleteDoc.title'),
                message: this.translateService.instant('companies.detail.privacyDocsCard.studioSection.dialog.deleteDoc.message'),
                btnOkText: this.translateService.instant('common.cta.confirm'),
                btnCancelText: this.translateService.instant('common.cta.close'),
            },
            width: '500px',
            disableClose: true
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res2) {
            if (res2) {
                _this.privacyStudioDocsService.delete(_this.company.get("_id"), docId)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.privacyStudioDocsLoadPage();
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                });
            }
        });
    };
    /**
     * Handler View standard QRcode doc
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsViewQrcode = function (data) {
        this.dialog.open(PrivacyStudioDocsQrCodeDialogComponent, {
            data: {
                data: data,
                print: false,
            },
            width: "450px",
        });
    };
    /**
     * Handler Print standard QRcode doc
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsPrintQrcode = function (data) {
        this.dialog.open(PrivacyStudioDocsQrCodeDialogComponent, {
            data: {
                data: data,
                print: true,
            },
            width: "450px",
        });
    };
    /**
     * Handler download files
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsDownload = function (data) {
        this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                documents: data.files,
            },
            width: "600px",
        });
    };
    /**
     * Update docs list to send by email
     *
     * @since 1.0.0
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocSelected = function (doc, checked) {
        if (doc && checked) {
            this.selectedPrivacyStudioDocs.push(doc);
        }
        else if (doc && !checked) {
            var index = this.selectedPrivacyStudioDocs.indexOf(doc._id);
            this.selectedPrivacyStudioDocs.splice(index, 1);
        }
    };
    /**
     * Handle send selected docs by email
     */
    ViewCompanyComponent.prototype.onPrivacyStudioDocsSendByEmail = function () {
        var _this = this;
        var insertedDocs = [];
        var selectedDocs = [];
        this.selectedPrivacyStudioDocs.forEach(function (doc) {
            selectedDocs.push(doc._id);
            var data = {
                document: doc.files,
            };
            insertedDocs.push({
                docId: doc._id,
                title: doc.type,
                data: data,
            });
        });
        var newMessageDialogRef = this.newMessageDialog.open(SendEmailDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                phonebook: this.company.get("phonebook")
                    ? this.company.get("phonebook")
                    : [],
                insertedDocs: insertedDocs,
                selectedDocs: selectedDocs,
                companyData: this.loggedUserMaster ? this.companyData : "",
                propertyName: "",
                propertyId: "",
                sentFromSupplierPage: false,
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        newMessageDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
        });
    };
    return ViewCompanyComponent;
}());
export { ViewCompanyComponent };
